"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _base = _interopRequireDefault(require("../../../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SidebarHeaderStyle = _styledComponents.default.div`
  background-color: ${({
  theme
}) => theme.colors.white};
  box-shadow: inset 0 -1px 0 0 ${({
  theme
}) => theme.disabled.border};
  box-sizing: border-box;
  width: 100%;
  color: ${({
  theme
}) => theme.text.color};
  transition: all 0.2s ease;
  padding: 27px 32px 32px 32px;
`;
SidebarHeaderStyle.defaultProps = {
  theme: _base.default
};
var _default = SidebarHeaderStyle;
exports.default = _default;